import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function initializeAnchorsBlock(root) {
    if (!root || root.dataset.anchorsInitialized === 'true') {
        return;
    }

    const swiperContainer = root.querySelector('.swiper');

    if (!swiperContainer) {
        return;
    }

    root.dataset.anchorsInitialized = 'true';

    new Swiper(swiperContainer, {
        slidesPerView: 'auto',
        spaceBetween: 28,
        modules: [Navigation],
        navigation: {
            nextEl: root.querySelector('.swiper-button-next'),
            prevEl: root.querySelector('.swiper-button-prev')
        },
        breakpoints: {
            1024: {
                spaceBetween: 120
            }
        }
    });
}

function initializeFrontend() {
    document.querySelectorAll('.anchors').forEach(initializeAnchorsBlock);
}

if (window.acf) {
    window.acf.addAction('render_block_preview/type=anchors', ($block) => {
        initializeAnchorsBlock($block.get(0));
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFrontend);
} else {
    initializeFrontend();
}